import { lazy } from '@/service/lazy'

export default [{
  name: 'Novos Cadastros',
  path: 'novos-cadastros',
  id: 'novos-cadastros',
  icon: 'fa fa-user',
  component: lazy('app/default/relatorios/novoscadastros/index'),
  meta: { requireAuth: true, rules: ['visualizar_novos_cadastros'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/novoscadastros.js